<template>
  <div class="styling-box-wrapper">
    <h4>Styling</h4>
    <div
      data-testid="product-list"
      class="products flex flex-wrap"
      v-if="box.length"
    >
      <div
        class="product-wrapper flex flex-column small-margin-bottom clickable"
        v-for="product in box"
        :key="product.variantId"
      >
        <span
          class="product-size uppercase"
          :class="{ 'error-case': product.filteredReason }"
        >
          {{ product.variants.size }}
        </span>
        <img
          :src="
            product.allImages && product.allImages.length
              ? product.allImages.find((el) => el.is_primary).urls.original ||
                product.allImages[0].urls.original
              : product.images.thumbnail
          "
          class="product-image hover-effect"
          @click="$emit('selectProduct', product)"
        />
        <button
          data-testid="remove-styling"
          class="btn-remove clickable hover-effect no-padding"
          :ref="'btn-remove-' + product.variantId"
          @click="removeItem(product.variantId)"
        >
          &times;
        </button>
      </div>
    </div>
    <div data-testid="no-products" class="products flex" v-else>
      There are no products in the styling box yet
    </div>
    <div class="buttons-wrapper flex">
      <button
        class="btn-sm extremely-small-margin bg-dark-grey"
        @click="$emit('editLetter')"
      >
        CREATE OUTFITS
      </button>
      <button
        class="btn-sm extremely-small-margin bg-sky-blue"
        @click="$emit('showBoxModal')"
      >
        View box
      </button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Product from './Product.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'StylingBox',
  props: {
    box: {
      type: Array,
      default: () => []
    },
    complete: {
      type: Boolean,
      default: false
    }
  },
  components: {
    Product
  },
  data () {
    return {
      isComplete: true
    }
  },
  computed: {
    ...mapGetters([
      'getTestStylist'
    ])
  },
  mounted () {
    this.isComplete = this.complete;
  },
  watch: {
    complete (value) {
        this.isComplete = value;
    }
  },
  methods: {
    removeItem (id) {
      this.$refs['btn-remove-' + id][0].disabled = true
      this.$emit('removeProduct', id)
    },

    test () {
      console.log('test')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../styles/variables.less";

.extremely-small-margin {
  margin: 2px;
}

.styling-box-wrapper {
  padding: 10px;

  .products {
    margin-bottom: 10px;

    .product-wrapper {
      width: 25%;
      justify-content: center;
      align-items: center;

      .product-size {
        font-size: 15px;
        padding: 1px 4px;
        font-weight: 500;

        &.error-case {
          color: red;
          font-weight: 900;
        }
      }

      .product-image {
        height: 50px;
      }

      .btn-remove {
        width: 20px;
        height: 20px;
        border-radius: 50%;
        font-size: 12px;
        text-align: center;
        line-height: 20px;
        color: #fff;
        background-color: #f4815d;
        margin-top: 5px;
      }
    }
  }
}

.buttons-wrapper {
  button {
    border: 1px solid #888;
  }
}

.hover-effect:hover {
  transform: scale(1.1);
}
</style>
